import React, { Component } from 'react'
import { IntlProvider, injectIntl, FormattedMessage } from 'react-intl'
import createAxios from 'utils/axios'

// Constants
import { DEFAULT_LOCALE, CHINA_REGION } from 'components/dashboard/constants'

// Components
import Layout from '../layout'
import IdentityForm from './identity_form'
import NewPasswordForm from './new_password_form'

class ForgotPasswordApp extends Component {
  constructor(props) {
    super(props)

    this.state = {
      recoveryToken: '',
      checkingToken: false,
      isTokenInvalid: false,
    }
  }

  link(url) {
    const locale = (DEFAULT_LOCALE === this.props.locale) ? '' : `/${this.props.locale}`
    return `${locale}${url}`
  }

  componentDidMount() {
    this.axios = createAxios({
      intl: this.props.intl
    })

    const match = window.location.href.match(/forgot_password\/(.+)$/)

    if (match) {
      const recoveryToken = match[1]

      this.setState({ checkingToken: true })

      const url = `/check_password_recovery_token/${recoveryToken}`

      this.axios.get(url).then(({ data }) => {
        if (data.errors) {
          this.setState({ isTokenInvalid: true })
        } else {
          this.setState({ recoveryToken: recoveryToken })
        }

        this.setState({ checkingToken: false })
      })
    }
  }

  render() {
    const hasToken = this.state.recoveryToken.length > 0
    const form = hasToken
     ? <NewPasswordForm recoveryToken={this.state.recoveryToken} token={this.props.token} locale={this.props.locale} />
     : <IdentityForm token={this.props.token} locale={this.props.locale} isChinaVersion={this.props.isChinaVersion} />

    let content = this.state.isTokenInvalid ? (
      <div>
        <h4><FormattedMessage id="ForgotPassword.RecoveryTokenInvalid" /></h4>
        <a href={this.link('/forgot_password')} className='button button-dark-blue'>
          <FormattedMessage id="ForgotPassword.TryAgain" />
        </a>
      </div>
    ) : form

    if (this.state.checkingToken) {
      content = (
        <div className="wrapper">
          <div className="cssload-loader"></div>
        </div>
      )
    }

    return (
      <IntlProvider locale={this.props.intlLocale} messages={this.props.messages}>
        <Layout
          locale={this.props.locale}
          intlLocale={this.props.intlLocale}
          messages={this.props.messages}
          resources={this.props.resources}
          region={this.props.region}>

          <div className="forgot_password">
            <h3><FormattedMessage id="ForgotPassword.Header" /></h3>
            {content}
          </div>
        </Layout>
      </IntlProvider>
    )
  }
}

export default injectIntl(ForgotPasswordApp)



// WEBPACK FOOTER //
// ./app/javascript/components/application/forgot_password/app.js